import { render, staticRenderFns } from "./StepsCounter.vue?vue&type=template&id=460c6a8f&scoped=true&"
import script from "./StepsCounter.vue?vue&type=script&lang=js&"
export * from "./StepsCounter.vue?vue&type=script&lang=js&"
import style0 from "./StepsCounter.vue?vue&type=style&index=0&id=460c6a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c6a8f",
  null
  
)

export default component.exports